import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange } from '@angular/core';
import {SiteDiaryItem, SiteDiaryService} from '../../services/SiteDiary.service';

declare var laydate: any;
declare let layui: any

@Component({
  selector: 'SiteDiaty-Activity-New',
  templateUrl: './SiteDiaty-Activity-New.component.html',
  styleUrls: ['./SiteDiaty-Activity-New.component.sass']
  
})
export class SiteDiatyActivityNewComponent implements OnChanges {

  @Input() public divClick:any
  @Input() public summaryData: SiteDiaryItem
  @Input() public isEdit:any
  public addActivty:any

  @Output() tableEdit = new EventEmitter();

  public tableList1 = []
  public tableList2 = []
  public tableList3 = []
  public tableList4 = []
  public tableList5 = []
  public tableList6 = []
  public tableList7 = []
  public tableList8 = []
  public tableList9 = []
  public tableList10 = []

  public modulesize:any = []   //module页码
  public modulepage=1

  public per = 999
  public oneShow:any
  public twoShow:any
  public threeShow:any
  public fourShow:any
  public fiveShow:any
  public sixShow:any
  public sevenShow:any
  public eightShow:any
  public nineShow:any
  public tenShow:any
  public teamList:any
  public copyTeamList:any=[
    {
      name:'All',
      id:''
    },
    {
      name:'Team 1',
      id:'team_one'
    },
    {
      name:'Team 2',
      id:'team_two'
    },
    {
      name:'Team 3',
      id:'team_three'
    },
    {
      name:'Team 4',
      id:'team_four'
    },
    {
      name:'Team 5',
      id:'team_five'
    },
    {
      name:'Team 6',
      id:'team_six'
    },
    {
      name:'Team 7',
      id:'team_seven'
    },
    {
      name:'Team 8',
      id:'team_eight'
    },
    {
      name:'Team 9',
      id:'team_nine'
    },
    {
      name:'Team 10',
      id:'team_ten'
    },
  ]
  public updataActivty:any = null
  public editIndex:any
  public copyIndex:any
  public copyShow:any = false
  public copyList = []
  public copyCheckAll:any = false
  public currentId:any = 0
  public filterName:any=''
  public copyListBack:any=[]

  constructor(
    public service: SiteDiaryService,
  ) { }

  ngOnInit() {
    // this.getList()
    this.service.getTeamList(this.summaryData.id).subscribe( (res) => {
      //console.log(res)
      this.teamList = res
    })
    const currentUser: any = document.querySelector('meta[name=current_user]');
    this.currentId = currentUser.dataset.id
    // console.log(this.summaryData.daily_date)
    // console.log('divClick',this.divClick)
  }
  changeTeam() {
    if(this.copyListBack.length<=0){
      this.copyListBack = this.copyList
    }
    if(this.filterName == '') {
      this.copyList = this.copyListBack
    } else {
      this.copyList = this.copyListBack.filter( (item:any) => {
        return item.activity_team.indexOf(this.filterName) != -1
      })
    }
  }
  checkAll() {
    this.copyList.forEach( (item:any) => {
        item.copy = !this.copyCheckAll
    })
  }
  copySubmit() {
    let copyarr = this.copyList.filter( (item:any) => {
      return item.copy
    }).map( (item:any) => {
      return item.id
    })
    //console.log(copyarr)

    this.service.copyActivity(this.summaryData.id,this.copyIndex, copyarr).subscribe( (res:any) => {
        //console.log(res)
        this.getList(this.copyIndex)
        this.closeCopy()
    })
  }
  addActivtyClick(index:any){
    if(index) {
      this.editIndex = index
    } else {
      this.getList(this.editIndex)
    }
    this.updataActivty = null
    this.addActivty = !this.addActivty
    jQuery('#top-menu').css('z-index','unset')

  }
  // 按钮权限
  permissionBtn(){
    if(this.summaryData.state == 'draft'||this.summaryData.state=='rejected'|| (this.summaryData.pm_user.id == this.currentId&&this.summaryData.state == 'sent')){
      return true
    }else{
      return false
    }
  }
  dropDown(index:any) {
    switch (index) {
      case 1: {
        this.oneShow = !this.oneShow 
        this.getList(index)
      };break;
      case 2: {
        this.twoShow = !this.twoShow
        this.getList(index)
      }break;
      case 3: {
        this.threeShow = !this.threeShow 
        this.getList(index)
      }break;
      case 4: {
        this.fourShow = !this.fourShow
        this.getList(index)
      }break;
      case 5: {
        this.fiveShow = !this.fiveShow
        this.getList(index)
      }break;
      case 6: {
        this.sixShow = !this.sixShow
        this.getList(index)
      }break;
      case 7: {
        this.sevenShow = !this.sevenShow
        this.getList(index)
      }break;
      case 8: {
        this.eightShow = !this.eightShow
        this.getList(index)
      }break;
      case 9: {
        this.nineShow = !this.nineShow
        this.getList(index)
      }break;
      case 10: {
        this.tenShow = !this.tenShow
        this.getList(index)
      }break;
    }
  }
  //监听父组件传递过来的值
  ngOnChanges(changes:{[propKey:string]: SimpleChange }){
    //console.log(changes)
    // if(changes['addActivty']){
    //   if(!changes['addActivty']['currentValue'])this.getList()
    // }
    // if(changes['divClick']){
    //   this.getList()
    // }
  }

  //获取labour列表数据
  getList(index:any) {
    let data = {site_diary_id:this.summaryData.id ,page:this.modulepage ,per:this.per,activity_team: index}

      this.service.getActivitiesList(data).subscribe((res:any)=>{
        //console.log(res)
        let gettableList = ('tableList' + index) as any
        let that = this as any
        that[gettableList]= res.activities
        this.service.getTeamList(this.summaryData.id).subscribe( (res) => {
          //console.log(res)
          this.teamList = res
        })
        // this.setCountList(res.activities.length,res.count)
      })
    
  }

  //分页处理
  setCountList(length:any,count:any){
    //console.log(Math.ceil(count/this.per))
    this.modulesize = []
    for(let i =0;i<Math.ceil(count/this.per);i++){
      this.modulesize.push("i")
      //console.log(this.modulesize)
    }
  }

  modulego(leftright:any){
    if(leftright == 'prev'){
      this.modulepage = this.modulepage>this.modulesize.length ? this.modulepage : this.modulepage-1
    }
  }
  closeCopy() {
    this.copyCheckAll = false
    this.copyShow = false
  }
  copyClick(index:any) {
    this.copyListBack = []
    this.copyIndex = index
    this.service.getCopyFormList(this.summaryData.daily_date, index,this.summaryData.id).subscribe( (res:any) => {
      const teamName:any = {
        'team_one': 'Team 1',
        'team_two': 'Team 2',
        'team_three': 'Team 3',
        'team_four': 'Team 4',
        'team_five': 'Team 5',
        'team_six': 'Team 6',
        'team_seven': 'Team 7',
        'team_eight': 'Team 8',
        'team_nine': 'Team 9',
        'team_ten': 'Team 10',
      };
      this.copyList = res.activities.sort((a: {activity_team: string}, b: {activity_team: string}) => {
        const teamOrder = ['team_one', 'team_two', 'team_three', 'team_four', 'team_five', 'team_six', 'team_seven', 'team_eight', 'team_nine', 'team_ten'];
        
        return teamOrder.indexOf(a.activity_team) - teamOrder.indexOf(b.activity_team);
      }).map((item:any) => {
        return {
          ...item,
          team_name: teamName[item.activity_team]
        };
      })
    })
    
    this.copyShow  = true
      setTimeout(() => {
        const teamName:any = {
          'team_one': 'Team 1',
          'team_two': 'Team 2',
          'team_three': 'Team 3',
          'team_four': 'Team 4',
          'team_five': 'Team 5',
          'team_six': 'Team 6',
          'team_seven': 'Team 7',
          'team_eight': 'Team 8',
          'team_nine': 'Team 9',
          'team_ten': 'Team 10',
        };
        laydate.render({ 
          elem: '#activetyCopyDate'
          ,type: 'date',
          value: this.summaryData.daily_date,
          done: (value:any) => {
            this.service.getCopyFormList(value, index,this.summaryData.id).subscribe( (res:any) => {
              this.copyCheckAll = false
              this.copyList = res.activities.sort((a: {activity_team: string}, b: {activity_team: string}) => {
                const teamOrder = ['team_one', 'team_two', 'team_three', 'team_four', 'team_five', 'team_six', 'team_seven', 'team_eight', 'team_nine', 'team_ten'];
                return teamOrder.indexOf(a.activity_team) - teamOrder.indexOf(b.activity_team);
              }).map((item:any) => {
                const teamNum = item.activity_team.split('_')[1];
                return {
                  ...item,
                  team_name: teamName[item.activity_team]
                };
              })
            })
          }
        });
      }, 50)
  }
  //修改按钮
  editClick(item:any, index:any){
    this.editIndex = index
    jQuery('#top-menu').css('z-index','unset')
    this.updataActivty = item
    this.addActivty = !this.addActivty
  }

  deleteClick(item:any, indexs:any){
    let self = this
    layui.use(['layer' ], function() {
      let layer = layui.layer
      layer.confirm('Confirm to delete?', {
        btn: ['Yes ', 'No',], //可以无限个按钮
        title:'warning',
        yes: function(index:any){
          self.service.deleteActivities({site_diary_id:self.summaryData.id,activity_id:item.id}).subscribe((res:any)=>{
            self.getList(indexs)
          layer.close(index);
        })
        },
        btn2:function (index:any){
          layer.close(index);
        }
      })
    })
    // this.tableEdit.emit(item)
  }

}

